// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-trigger.a.dropdown-item.is-active {\n  background-color: #ff3860;\n}\n", ""]);
// Exports
module.exports = exports;
